import * as React from 'react';

function SvgIconClose(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <path d="M9.22 8L16 1.22 14.78 0 8 6.78 1.22 0 0 1.22 6.78 8 0 14.78 1.22 16 8 9.22 14.78 16 16 14.78 9.22 8z" />
    </svg>
  );
}

export default SvgIconClose;
